<template>
  <div class="invoice-controls" key="one" v-if="canSend">
    <div v-if="!outGoingFunds">
      No invoice has been sent for {{ selectedMonth | monthName }}
      <el-button type="success" icon="el-icon-upload" size="small" @click="showInvoiceDialog = true" :loading="loading">Create invoice</el-button>

      <el-dialog :append-to-body="true" v-if="showInvoiceDialog" :top="showSelectDialog ? '15vh' : '2vh'" width="800px" custom-class="dialog-no-padding" :visible.sync="showInvoiceDialog">
        <invoice-select @select="showInvoice" :organization="data.organization" v-if="showInvoiceDialog && showSelectDialog" />
        <invoice-form
          :from="from"
          :to="to"
          :dueDate="formData.dueDate"
          :charge="formData.charge"
          :data="data"
          @close="showInvoiceDialog = false"
          v-if="showInvoiceDialog && !showSelectDialog" />
      </el-dialog>
    </div>
    <div v-else>
      Account number
      <span>{{ data.organization.accountNumber }}</span>
    </div>
  </div>
  <div class="invoice-controls" key="two" v-else>
    Invoice has been sent for {{ selectedMonth | monthName }} at {{ new Date() | simpleDate }}
    <el-button type="text" :loading="loadingViewInvoice" @click="viewInvoice" icon="el-icon-view">View invoice</el-button>

    <el-dialog :append-to-body="true" v-if="showInvoiceDialog" width="800px" top="2vh" custom-class="dialog-no-padding" :visible.sync="showInvoiceDialog">
      <invoice v-if="showInvoiceDialog" :invoice="invoice" />
    </el-dialog>
  </div>
</template>

<script>
import Invoice from '@/components/front/invoice/Invoice'
import InvoiceForm from './InvoiceForm'
import InvoiceSelect from './InvoiceSelect'

export default {
  name: 'InvoiceControls',
  components: { Invoice, InvoiceForm, InvoiceSelect },
  props: {
    outGoingFunds: [Boolean],
    selectedMonth: {
      type: Number,
      required: true
    },
    from: {
      type: Date,
      required: true
    },
    to: {
      type: Date,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      formData: {
        dueDate: null,
        charge: false
      },
      showInvoiceDialog: false,
      showSelectDialog: true,
      loading: false,
      loadingViewInvoice: false,
      canSend: !this.data.hasInvoice,
      invoice: {}
    }
  },
  watch: {
    showInvoiceDialog (val) {
      if (!val) {
        this.showSelectDialog = true
      }
    }
  },
  methods: {
    showInvoice (charge, dueDate) {
      this.formData.charge = charge
      if (charge) {
        this.formData.dueDate = new Date()
      } else {
        this.formData.dueDate = dueDate
      }
      this.showInvoiceDialog = false
      setTimeout(() => {
        this.showSelectDialog = false
        this.showInvoiceDialog = true
      }, 300)
    },
    async viewInvoice () {
      this.loadingViewInvoice = true
      const response = await this.$http.get(this.$api.invoices.index(this.data.organization.id, this.selectedMonth + 1))
      this.invoice = response.data
      this.showInvoiceDialog = true
      this.loadingViewInvoice = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .is-sent {
    color: $green;
    display: flex;
    align-items: center;
    font-size: 14px;
  }

  .invoice-controls {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 80px;
    border-bottom: 1px solid $bg;
    padding: 0px 20px;

    div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 80px;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/billing-overview/InvoiceControls.vue